import { render, staticRenderFns } from "./ProductsRecommended.vue?vue&type=template&id=20f7ea2a&"
import script from "./ProductsRecommended.js?vue&type=script&lang=js&"
export * from "./ProductsRecommended.js?vue&type=script&lang=js&"
import style0 from "./ProductsRecommended.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports